module.exports = __webpack_public_path__ + "img/icon-fund-sky-blue.a2b11a4c.svg";